














import { defineComponent, PropType, ref, toRef, watch } from "@vue/composition-api";
import { PurchasedItem } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";
import { getElement } from "@/lib/elementHelpers";
import InfiniteScroll from "@/components/InfiniteScroll/InfiniteScroll.vue";
import PurchasedCover from "../PurchasedCover";

export default defineComponent({
  name: "GalleryGrid",
  components: { PurchasedCover, InfiniteScroll },
  props: {
    items: { type: Array as PropType<PurchasedItem[]>, required: true },
    enableScroll: { type: Boolean, default: true },
    selectedItemId: { type: String },
    isFeedView: { type: Boolean },
  },
  setup(props) {
    const purchasedItems = ref();
    watch(toRef(props, "isFeedView"), newVal => {
      if (newVal) return;
      const index = props.items.findIndex(i => i.id === props.selectedItemId);
      if (~index) {
        getElement(purchasedItems.value[index]).scrollIntoView({ behavior: "auto", block: "center" });
      }
    });

    return { purchasedItems };
  },
});
